module.exports = function (bootstrap) {
  bootstrap.directive('overallReviews', function () {
      return {
          restrict: 'A',
          replace: true,
          scope: false,
          template: require('directives/overallReviews.html'),
          controller: ['$scope', '$state', 'sessionData', 'coremetrics', function ($scope, $state, sessionData, coremetrics) {

              if (sessionData.basicInfo&&sessionData.basicInfo.role&&~["ba", "bacancelled", "agent", "agency_admin"].indexOf(sessionData.basicInfo.role.toLowerCase())) {
                  $scope.suppressPER = true;
              }

              $scope.isProfessional = function(details) {
                  return !!(details && details.professionalInfo && details.professionalInfo.displayName);
              };

              $scope.goToDisclaimer = function () {

                  //if ($scope.isProfessional) {
                  //    coremetrics.elementTag($scope.parentConfig.categoryId + ':DETAILS:PHYSICIAN WRITE A REVIEW', $scope.parentConfig.categoryId + ':DETAILS');
                  //} else {
                  //    coremetrics.elementTag($scope.parentConfig.categoryId + ':DETAILS:FACILITIES WRITE A REVIEW', $scope.parentConfig.categoryId + ':DETAILS');
                  //}

                  $state.go('providers.reviewDisclaimer', {
                      displayName: $state.params.displayName,
                      practitionerId: $state.params.practitionerId,
                      vendorId : $state.params.vendorId,
                      locationSequenceNumber: $state.params.locationSequenceNumber,
                      productId: $state.params.productId
                  });
              };
          }]
      };
  });
};